












import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

@Component({})
export default class Radiobutton extends Vue {
  @Prop() title!: string;
  @Prop({ default: false, type: Boolean }) checked!: boolean;
}
